import { RouteComponentProps } from '@reach/router';
import { DEFAULT, RouteSpec } from 'components/app/routing';
import React, { ReactNode } from 'react';
import Arcade from 'routes/arcade';
import Arcades from 'routes/arcades';
import CompanyContainer from 'routes/CompanyContainer';
import { NotFound } from 'routes/NotFound';
import {
    ARCADE_PATH_CREATE,
    ARCADE_PATH_UPDATE,
    ARCADES_PATH,
    COMPANY_PATH,
    OIDC_SIGNIN,
    ROM_PATH_CREATE,
    ROM_PATH_UPDATE,
    ROMS_PATH,
    TOKENS_PATH,
    // TOKENS_PATH_CREATE,
    TOKENS_PATH_LIST
} from 'routes/paths';
import { RedirectAfterOidcSignin } from 'routes/RedirectAfterOidcSignin';
import { RootRedirectToCompany } from 'routes/RedirectToCompany';
import Rom from 'routes/rom';
import Roms from 'routes/roms';
// import { CreateTokenForm } from 'routes/tokens/create';
import { TokenList } from 'routes/tokens/list/TokenList';
import UpdateContentForm from 'routes/updatecmx';

const Container = (props: { children: ReactNode }) => <>{props.children}</>;

const StudioForm = ({ children }: RouteComponentProps & { children: ReactNode[] }) => <div>{ children }</div>;

const CreateArcadeForm = props => <Arcade {...props} />;
const UpdateArcadeForm = props => <Arcade {...props} />;
const CreateRomForm = props => <Rom {...props} />;
const UpdateRomForm = props => <><Rom {...props} /><UpdateContentForm {...props} /></>;

/**
 * All routes in the application
 */
export const ROUTE_MAP: RouteSpec = {
    [COMPANY_PATH]: {
        component: CompanyContainer,
        children: {
            [ARCADES_PATH]: {
                label: 'Arcades',
                component: StudioForm,
                children: {
                    '/': { component: Arcades },
                    [ARCADE_PATH_CREATE]: { component: CreateArcadeForm, label: 'Create New Arcade' },
                    [ARCADE_PATH_UPDATE]: { component: UpdateArcadeForm, label: 'Update Arcade' },
                }
            },
            [ROMS_PATH]: {
                label: 'ROMs',
                component: StudioForm,
                children: {
                    '/': { component: Roms },
                    [ROM_PATH_CREATE]: { component: CreateRomForm, label: 'Create new ROM' },
                    [ROM_PATH_UPDATE]: { component: UpdateRomForm, label: 'Update ROM' },
                }
            },
            [TOKENS_PATH]: {
                label: 'Tokens',
                component: Container,
                children: {
                    // [TOKENS_PATH_CREATE]: { component: CreateTokenForm, label: 'Create Tokens' },
                    [TOKENS_PATH_LIST]: { component: TokenList, label: 'List Tokens' },
                    '*': { redirectTo: `.${TOKENS_PATH_LIST}` },
                },
            },

            '/': { redirectTo: `.${ARCADES_PATH}` },

            [DEFAULT]: { component: NotFound }
        },
    },

    // The OIDC callback endpoint for the login flow needs its own path
    // because we don't know where to redirect to until it finishes.
    [OIDC_SIGNIN]: { component: RedirectAfterOidcSignin },

    [DEFAULT]: { component: RootRedirectToCompany },
};
